<div class="tag-item-container caption">    
    <span>{{text}}</span>
    <button *ngIf="!readonly" class="btn-small nu-btn-icon button-delete" (click)="deleteTags.next(text)">
        <svg class="nu-icon"><use xlink:href="./assets/icons/symbol-defs.svg#nu-ic-close-thin"></use></svg>
    </button>
</div>